import PropTypes from "prop-types";
import AspectPropType from "./aspect";

export default PropTypes.shape({
    aspects: PropTypes.objectOf(AspectPropType).isRequired,
});
